module.exports = __webpack_public_path__ + "static/img/balzw909.656024b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balzw909.jpg
// module id = gbnA
// module chunks = 0